// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const getTotalChargedCredits = (order: IOrder) => {
  // CreditAcreage - base credit acreage
  const creditAcreage = order.creditAcreage || 0;

  // Adjusted Credits - sum of all credit adjustments
  const adjustedCredits = order.adjustedAcres || 0;

  // Total = CreditAcreage + Adjusted Credits
  return creditAcreage + adjustedCredits;
};

export default getTotalChargedCredits;
